export const FOLLOWERS_LOADING = 'followers.LOADING';
export const FOLLOWERS_LOADED = 'followers.LOADED';
export const FOLLOWERS_ERROR = 'followers.ERROR';



// WEBPACK FOOTER //
// ./src/stores/followers/action_types.js